import { Suspense, useEffect, useState } from 'react';
import './App.scss';
import { useLocation } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import MainNavbar from '../../components/MainNavbar';
import useWindowSize from '../../helpers/hooks/useWindowSize';
import MainFooter from '../../components/MainFooter';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import initialization from '../../helpers/initialization';
import { setLoggedInStatus } from '../../redux/slicers/authenticationSlice';
import deinitialization from '../../helpers/deinitialization';
import useGoogleTracking from '../../helpers/hooks/useGoogleTracking';
import AppRoutes from '../../router/routes';

const App = () => {
	const dispatch = useAppDispatch();

	// Hook for checking users window size
	const windowSize = useWindowSize();
	const location = useLocation();

	const loggedIn = useAppSelector((state) => state.authentication.loggedIn);
	const selectedRoom = useAppSelector((state) => state.room.selectedRoom);

	// TEMPORARY LOADING LOGIC
	const [loading, setLoading] = useState<boolean>(true);
	const [isLoginView, setIsLoginView] = useState<boolean>(true);
	const [isRoomView, setIsRoomView] = useState<boolean>(false);

	useGoogleTracking();

	useEffect(() => {
		(async () => {
			setLoading(true);
			const user = await initialization.initializeUser();
			if (user) {
				const status = await initialization.initializeData(user, true);
				if (status) {
					await dispatch(setLoggedInStatus(true));
				} else {
					deinitialization.userLogout(true);
				}
			}
			setLoading(false);
		})();
	}, [dispatch]);

	useEffect(() => {
		const path = location.pathname.split('/');
		document.title = definePageTile(path);
		setIsRoomView(path[1] === 'room');
		setIsLoginView(path[1] === 'login');

		function definePageTile(title: string[]): string {
			switch (title[1]) {
				case 'login':
					return 'Viral | Log in';
				case 'dashboard':
					return 'Viral | Dashboard';
				case 'room':
					if (selectedRoom) {
						if (title[3]) {
							return `Viral | ${selectedRoom.name} Edit `;
						} else {
							return `Viral | ${selectedRoom.name} `;
						}
					} else {
						return 'Viral';
					}
				default:
					return 'Viral';
			}
		}
	}, [location, selectedRoom]);

	function logout() {
		deinitialization.userLogout(true);
	}

	return !loading ? (
		<div className={`App d-flex flex-column min-vh-100 ${isLoginView && 'login-page'} `}>
			<MainNavbar windowSize={windowSize} isLoggedIn={loggedIn} emitLogout={logout} />
			<main className={`${!isLoginView ? 'mt-4' : 'my-auto'}  `}>
				<Container>
					<Suspense fallback={<h5>Loading...</h5>}>
						<AppRoutes></AppRoutes>
					</Suspense>
				</Container>
			</main>
			<MainFooter isLoggedIn={!isLoginView} isRoomView={isRoomView} />
		</div>
	) : (
		<></>
	);
};

export default App;
